import type { FunctionComponent } from 'react';
import { Container } from '../../../../components/layout/grid';
import type { BentoPieceRectangleThreePartsFragment } from '../../../../graphql/fragments/BentoPieceRectangleThreePartsFragment.graphql';
import styles from './bento-rectangle-three-parts.module.scss';
import Part from './part';
export const BentoRectangleThreeParts: FunctionComponent<Props> = ({
  parts
}) => {
  return <div className={styles.wrapper} data-sentry-component="BentoRectangleThreeParts" data-sentry-source-file="bento-rectangle-three-parts.tsx">
            <Container className={styles.container} data-sentry-element="Container" data-sentry-source-file="bento-rectangle-three-parts.tsx">
                {parts?.items.map(part => <Part key={part.sys.id} heading={part.heading} copy={part.copy} image={part.image} />)}
            </Container>
        </div>;
};
export default BentoRectangleThreeParts;
type Props = Omit<BentoPieceRectangleThreePartsFragment, 'sys' | 'type'> & {
  index?: number;
};